import * as React from 'react'

import ModelConatiner from './ModelConatiner'

function Pruebas() {
  //cargar un modelo el cual se posicionara en el mundo real con AR al hacer clic
  return <ModelConatiner />
}

export default Pruebas
